var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockTokeno(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53918 9H0.461805C0.206675 9 0 8.80898 0 8.57296V4.00041C0 3.76347 0.205686 3.57153 0.461805 3.57153H1.23115V2.57235C1.23115 1.15163 2.47021 0 3.99901 0C5.52979 0 6.76885 1.15163 6.76885 2.57235V3.57153H7.53918C7.79333 3.57153 8 3.76347 8 4.00041V8.57296C8 8.80898 7.79333 9 7.53918 9ZM3.5382 6.45337V7.28633C3.5382 7.52327 3.74388 7.7152 3.99901 7.7152C4.25513 7.7152 4.4618 7.52235 4.4618 7.28633V6.45337C4.73572 6.30551 4.92262 6.03276 4.92262 5.71592C4.92262 5.24204 4.50927 4.85816 3.99901 4.85816C3.49073 4.85816 3.07738 5.24204 3.07738 5.71592C3.07738 6.03184 3.26329 6.30459 3.5382 6.45337ZM5.84524 2.57235C5.84524 1.62459 5.01953 0.857755 3.99901 0.857755C2.97948 0.857755 2.15377 1.62459 2.15377 2.57235V3.57153H5.84524V2.57235Z",
    fill: "url(#paint0_linear_1673_198)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1673_198",
    x1: 4,
    y1: 0,
    x2: 4,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8051CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E679CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockTokeno);
export default __webpack_public_path__ + "static/media/LockTokeno.1ada7461.svg";
export { ForwardRef as ReactComponent };